import React, { useEffect } from 'react';
import { Hero } from '../components/diagnostico/Hero';
import { WhatIsICD } from '../components/diagnostico/WhatIsICD';
import { Dimensions } from '../components/diagnostico/Dimensions';
import { DiagnosticCTA } from '../components/home/DiagnosticCTA';
import { useLocation } from 'react-router-dom';
export function Diagnostico() {
  const location = useLocation();
  // Scroll to top when navigating to this page
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return <div className="w-full" data-id="element-421">
      <Hero data-id="element-422" />
      <WhatIsICD data-id="element-423" />
      <Dimensions data-id="element-424" />
      {/* Reusing the DiagnosticCTA from Home page as it fits perfectly here as the final conversion step */}
      <DiagnosticCTA data-id="element-425" />
    </div>;
}